import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SuiContainer, SuiTextInput, SuiLabel } from '@splashthat/sui';

import RichTextLabelControl from './components/RichTextLabelControl';
import EditViewSectionContainer from './EditViewSectionContainer';
import { getEditFormNodeId, getEditNodeOptions } from '../../selectors';
import { updateFormNodeOption as updateFormNodeOptionActionCreator } from '../../actions/nodeOptionActions';

const EXPLANATION_COPY = `
*Are you attending? question gives guests the possibility to RSVP as Not Attending.
If this question is omitted all guests will be registered as attendees.`;

const optionsDisplayLabels = {
    1: 'Attending',
    0: 'Not attending',
    default: 'Other',
};

const EditQuestionAttending = ({ formNodeId, updateFormNodeOption, options }) => (
    <EditViewSectionContainer>
        <SuiContainer variation="flex-group">
            <RichTextLabelControl formNodeId={formNodeId} />
        </SuiContainer>
        {options.map((option) => (
            <SuiContainer key={option.id} variation="flex-group">
                <SuiTextInput
                    fullWidth
                    multiLine
                    rows={2}
                    label={optionsDisplayLabels[option.value] || optionsDisplayLabels.default}
                    value={option.label}
                    onChange={(e, value) =>
                        updateFormNodeOption(formNodeId, option.id, {
                            label: value,
                        })
                    }
                />
            </SuiContainer>
        ))}
        <SuiLabel text={EXPLANATION_COPY} secondary />
    </EditViewSectionContainer>
);

EditQuestionAttending.propTypes = {
    updateFormNodeOption: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    formNodeId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    const formNodeId = getEditFormNodeId(state);
    const options = getEditNodeOptions(state);
    return {
        formNodeId,
        options,
    };
};

const mapDispatchToProps = {
    updateFormNodeOption: updateFormNodeOptionActionCreator,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditQuestionAttending);
